import { render, staticRenderFns } from "./RevokeApiKeyDialog.vue?vue&type=template&id=66ca704e&scoped=true&lang=pug&"
import script from "./RevokeApiKeyDialog.vue?vue&type=script&lang=js&"
export * from "./RevokeApiKeyDialog.vue?vue&type=script&lang=js&"
import style0 from "./RevokeApiKeyDialog.vue?vue&type=style&index=0&id=66ca704e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca704e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VDivider,VSpacer,VTextField})
